<template>
  <div class="seomain">
    <el-row class="top_wrap">
      <el-col class="top_content">
        <div class="title" v-if="active == 0">年租金总额(RMB)</div>
        <div class="title" v-if="active == 1">月租金总额(RMB)</div>
        <div class="title" v-if="active == 2">周租金总额(RMB)</div>
        <div class="amount">¥{{ data1.this_year_total + ".00" }}</div>
      </el-col>
    </el-row>

    <van-row :gutter="20" style="margin-top: 10px">
      <van-col :span="24" class="default_block_col text-center">
        <el-card shadow="hover" :body-style="{ padding: '0 5px' }">
          <van-tabs
            v-model="active"
            line-width="80px"
            color="#00baad"
            title-active-color="#51596e"
            title-inactive-color="#677588"
          >
            <van-tab title="年度租赁统计">
              <el-row :gutter="10" style="padding: 10px">
                <el-col :span="12">
                  <div class="sales_amount color_1">
                    ¥{{ data1.this_year_total }}
                  </div>
                  <div class="type_tag">租金</div>
                  <div class="sales_amount-2">
                    <span class="color_4">去年</span
                    ><span class="color_1">¥{{ data1.last_year_total }}</span>
                  </div>
                </el-col>
                <!-- <el-col :span="8">
                  <div class="sales_amount color_1">¥1188888.88</div>
                  <div class="type_tag">总成本</div>
                  <div class="sales_amount-2">
                    <span class="color_4">去年</span
                    ><span class="color_2">-¥88888.00</span>
                  </div>
                </el-col> -->
                <el-col :span="12">
                  <div
                    :class="[
                      'sales_amount',
                      data1.this_year_gp < 0 ? 'color_2' : 'color_1',
                    ]"
                  >
                    ¥&nbsp;{{ data1.this_year_gp }}
                  </div>
                  <div class="type_tag">毛利润</div>
                  <div class="sales_amount-2">
                    <span class="color_4">去年</span>
                    <span
                      :class="[data1.last_year_gp < 0 ? 'color_2' : 'color_1']"
                      >¥&nbsp;{{ data1.last_year_gp }}</span
                    >
                  </div>
                </el-col>
                <el-col>
                  <div class="unline"></div>
                </el-col>
                <el-col>
                  <div
                    id="myChart1"
                    ref="myChart1"
                    :style="{ width: '100%', height: '250px' }"
                  ></div>
                </el-col>
              </el-row>
            </van-tab>
            <van-tab title="月度租赁统计">
              <el-row :gutter="10" style="padding: 10px">
                <el-col :span="12">
                  <div class="sales_amount color_1">
                    ¥{{ data1.this_year_total }}
                  </div>
                  <div class="type_tag">租金</div>
                  <div class="sales_amount-2">
                    <span class="color_4">上月</span
                    ><span class="color_1">¥{{ data1.last_year_total }}</span>
                  </div>
                </el-col>
                <!-- <el-col :span="8">
                  <div class="sales_amount color_1">¥88988.88</div>
                  <div class="type_tag">总成本</div>
                  <div class="sales_amount-2">
                    <span class="color_4">上月</span
                    ><span class="color_2">-¥88888.00</span>
                  </div>
                </el-col> -->
                <el-col :span="12">
                  <div
                    :class="[
                      'sales_amount',
                      data1.this_year_gp < 0 ? 'color_2' : 'color_1',
                    ]"
                  >
                    ¥&nbsp;{{ data1.this_year_gp }}
                  </div>
                  <div class="type_tag">毛利润</div>
                  <div class="sales_amount-2">
                    <span class="color_4">上月</span>
                    <span
                      :class="[data1.last_year_gp < 0 ? 'color_2' : 'color_1']"
                      >¥&nbsp;{{ data1.last_year_gp }}</span
                    >
                  </div>
                </el-col>
                <el-col>
                  <div class="unline"></div>
                </el-col>
                <el-col>
                  <div
                    id="myChart2"
                    ref="myChart2"
                    :style="{ width: '100%', height: '250px' }"
                  ></div>
                </el-col>
              </el-row>
            </van-tab>
            <van-tab title="最近7日租赁统计">
              <el-row :gutter="10" style="padding: 10px">
                <el-col :span="12">
                  <div class="sales_amount color_1">
                    ¥{{ data1.this_year_total }}
                  </div>
                  <div class="type_tag">租金</div>
                  <div class="sales_amount-2">
                    <span class="color_4">上周</span
                    ><span class="color_1">¥{{ data1.last_year_total }}</span>
                  </div>
                </el-col>
                <!-- <el-col :span="8">
                  <div class="sales_amount color_1">¥7889888.88</div>
                  <div class="type_tag">总成本</div>
                  <div class="sales_amount-2">
                    <span class="color_4">上周</span
                    ><span class="color_2">-¥88888.00</span>
                  </div>
                </el-col> -->
                <el-col :span="12">
                  <div
                    :class="[
                      'sales_amount',
                      data1.this_year_gp < 0 ? 'color_2' : 'color_1',
                    ]"
                  >
                    ¥&nbsp;{{ data1.this_year_gp }}
                  </div>
                  <div class="type_tag">毛利润</div>
                  <div class="sales_amount-2">
                    <span class="color_4">上周</span>
                    <span
                      :class="[data1.last_year_gp < 0 ? 'color_2' : 'color_1']"
                      >¥&nbsp;{{ data1.last_year_gp }}</span
                    >
                  </div>
                </el-col>
                <el-col>
                  <div class="unline"></div>
                </el-col>
                <el-col>
                  <div
                    id="myChart3"
                    ref="myChart3"
                    :style="{ width: '100%', height: '250px' }"
                  ></div>
                </el-col>
              </el-row>
            </van-tab>
          </van-tabs>
        </el-card>
      </van-col>
    </van-row>

    <van-row :gutter="10" class="bottom_wrap">
      <van-col v-if="active == 0" :span="24" class="bold top-tit">
        年度租赁数据总览
      </van-col>
      <van-col v-if="active == 1" :span="24" class="bold top-tit">
        本月租赁数据总览
      </van-col>
      <van-col v-if="active == 2" :span="24" class="bold top-tit">
        本周租赁数据总览
      </van-col>
      <van-col :span="8" class="item_wrap">
        <div class="item_content">
          <div class="title color_4">已收租金</div>
          <div class="text color_4 bold">¥{{ data2.amount }}</div>
        </div>
      </van-col>
      <van-col :span="8" class="item_wrap">
        <div class="item_content">
          <div class="title color_4">出租数量</div>
          <div class="text color_4 bold">{{ data2.total }}</div>
        </div>
      </van-col>
      <van-col :span="8" class="item_wrap">
        <div class="item_content">
          <div class="title color_4">发票税费</div>
          <div class="text color_2 bold">¥{{ data2.tax }}</div>
        </div>
      </van-col>
      <van-col :span="8" class="item_wrap">
        <div class="item_content">
          <div class="title color_4">物流成本</div>
          <div class="text color_2 bold">¥{{ data2.shipping }}</div>
        </div>
      </van-col>
      <!-- <van-col :span="8" class="item_wrap">
        <div class="item_content">
          <div class="title color_4">折旧成本</div>
          <div class="text color_2 bold">¥884888.11</div>
        </div>
      </van-col> -->
      <!-- <van-col :span="8" class="item_wrap">
        <div class="item_content">
          <div class="title color_4">其他成本</div>
          <div class="text color_2 bold">¥8848.81</div>
        </div>
      </van-col> -->
      <van-col :span="8" class="item_wrap">
        <div class="item_content">
          <div class="title color_4">销售提成</div>
          <div class="text color_3 bold">¥{{ data2.commission }}</div>
        </div>
      </van-col>
      <van-col :span="8" class="item_wrap">
        <div class="item_content">
          <div class="title color_4">加工成本</div>
          <div class="text color_3 bold">¥{{ data2.processingfee }}</div>
        </div>
      </van-col>
      <van-col :span="8" class="item_wrap">
        <div class="item_content">
          <div class="title color_4">拆工成本</div>
          <div class="text color_3 bold">¥{{ data2.disassemfee }}</div>
        </div>
      </van-col>
      <!-- <van-col :span="8" class="item_wrap">
        <div class="item_content">
          <div class="title color_4">代收租金</div>
          <div class="text color_3 bold">¥8848.81</div>
        </div>
      </van-col> -->
      <van-col :span="8" class="item_wrap">
        <div class="item_content">
          <div class="title color_4">毛利润</div>
          <div class="text color_1 bold">¥{{ data2.gross_profit }}</div>
        </div>
      </van-col>
      <van-col :span="8" class="item_wrap">
        <div class="item_content">
          <div class="title color_4">毛利率</div>
          <div class="text color_1 bold">
            {{ data2.profit_Margin }}
          </div>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import echarts from "echarts";
import { Toast } from "vant";
export default {
  components: {},
  props: {},
  data() {
    return {
      active: "",
      info: {},
      year: {
        this_year_total: 0,
        last_year_total: 0,
        this_year_gp: 0,
        last_year_gp: 0,
        lists: {
          price: [],
          num: [],
          dates: [],
        },
        box: {
          profit_Margin: "",
          amount: "",
          total: "",
          tax: "",
          shipping: "",
          tariff: "",
          commission: "",
          processingfee: "",
          disassemfee: "",
          gross_profit: "",
        },
      },
      month: {
        this_year_total: 0,
        last_year_total: 0,
        this_year_gp: 0,
        last_year_gp: 0,
        lists: {
          price: [],
          num: [],
          dates: [],
        },
        box: {
          profit_Margin: "",
          amount: "",
          total: "",
          tax: "",
          shipping: "",
          tariff: "",
          commission: "",
          processingfee: "",
          disassemfee: "",
          gross_profit: "",
        },
      },
      day: {
        this_year_total: 0,
        last_year_total: 0,
        this_year_gp: 0,
        last_year_gp: 0,
        lists: {
          price: [],
          num: [],
          dates: [],
        },
        box: {
          profit_Margin: "",
          amount: "",
          total: "",
          tax: "",
          shipping: "",
          tariff: "",
          commission: "",
          processingfee: "",
          disassemfee: "",
          gross_profit: "",
        },
      },
      data1: {
        this_year_total: 0,
        last_year_total: 0,
        this_year_gp: 0,
        last_year_gp: 0,
      },
      data2: {
        profit_Margin: "",
        amount: "",
        total: "",
        tax: "",
        shipping: "",
        tariff: "",
        commission: "",
        processingfee: "",
        disassemfee: "",
        gross_profit: "",
      },
    };
  },
  watch: {
    active() {
      if (this.active == 0) {
        let obj = {};
        obj.this_year_total = this.year.this_year_total;
        obj.last_year_total = this.year.last_year_total;
        obj.this_year_gp = this.year.this_year_gp;
        obj.last_year_gp = this.year.last_year_gp;
        this.data1 = obj;

        this.data2 = this.year.box;
      } else if (this.active == 1) {
        let obj = {};
        obj.this_year_total = this.month.this_year_total;
        obj.last_year_total = this.month.last_year_total;
        obj.this_year_gp = this.month.this_year_gp;
        obj.last_year_gp = this.month.last_year_gp;
        this.data1 = obj;

        this.data2 = this.month.box;
      } else if (this.active == 2) {
        let obj = {};
        obj.this_year_total = this.day.this_year_total;
        obj.last_year_total = this.day.last_year_total;
        obj.this_year_gp = this.day.this_year_gp;
        obj.last_year_gp = this.day.last_year_gp;
        this.data1 = obj;

        this.data2 = this.day.box;
      }
    },
  },
  methods: {
    get_info: function () {
      this.$post(this.$api.stGetXiaoshouStatistics, { status: 1 }).then(
        (res) => {
          let { day, month, year } = res.data;
          this.day = day;
          this.month = month;
          this.year = year;

          let obj = {};
          obj.this_year_total = this.year.this_year_total;
          obj.last_year_total = this.year.last_year_total;
          obj.this_year_gp = this.year.this_year_gp;
          obj.last_year_gp = this.year.last_year_gp;
          this.data1 = obj;

          this.data2 = this.year.box;
        }
      );
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        overlay: true,
      });
    },
    echartInit: function () {
      /* 年度 */
      if (this.active == 0) {
        var myChart1 = echarts.init(this.$refs.myChart1);
        myChart1.setOption({
          // title: { text: "会员趋势" },
          tooltip: { trigger: "axis" },
          legend: {
            orient: "horizontal",
            left: "center",
            bottom: "10px",
            data: ["销售额", "订单量"],
          },
          color: ["#00baad", "#3c8ff7"],
          grid: {
            left: "20px",
            right: "20px",
            top: "5%",
            bottom: "60px",
            containcolor_3: true,
          },
          // toolbox: { feature: { saveAsImage: {} } },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.year.lists.dates,
          },
          yAxis: [
            {
              name: "销售额",
              type: "value",
              axisLabel: {
                formatter: function () {
                  return "";
                },
              },
            },
            {
              name: "订单量",
              type: "value",
              axisLabel: {
                formatter: function () {
                  return "";
                },
              },
            },
          ],
          series: [
            {
              name: "销售额",
              type: "line",
              data: this.year.lists.price,
              yAxisIndex: 0,
              smooth: true,
            },
            {
              name: "订单量",
              type: "line",
              data: this.year.lists.num,
              yAxisIndex: 1,
              smooth: true,
            },
          ],
        });
      }

      /* 月度 */
      if (this.active == 1) {
        var myChart2 = echarts.init(this.$refs.myChart2);
        myChart2.setOption({
          tooltip: { trigger: "axis" },
          legend: {
            orient: "horizontal",
            left: "center",
            bottom: "10px",
            data: ["销售额", "订单量"],
          },
          color: ["#00baad", "#3c8ff7"],
          grid: {
            left: "20px",
            right: "20px",
            top: "5%",
            bottom: "60px",
            containcolor_3: true,
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.month.lists.dates,
          },
          yAxis: [
            {
              name: "销售额",
              type: "value",
              axisLabel: {
                formatter: function () {
                  return "";
                },
              },
            },
            {
              name: "订单量",
              type: "value",
              axisLabel: {
                formatter: function () {
                  return "";
                },
              },
            },
          ],
          series: [
            {
              name: "销售额",
              type: "line",
              data: this.month.lists.price,
              yAxisIndex: 0,
              smooth: true,
            },
            {
              name: "订单量",
              type: "line",
              data: this.month.lists.num,
              yAxisIndex: 1,
              smooth: true,
            },
          ],
        });
      }
      /*  周 */

      if (this.active == 2) {
        var myChart3 = echarts.init(this.$refs.myChart3);
        myChart3.setOption({
          tooltip: { trigger: "axis" },
          legend: {
            orient: "horizontal",
            left: "center",
            bottom: "10px",
            data: ["销售额", "订单量"],
          },
          color: ["#00baad", "#3c8ff7"],
          grid: {
            left: "20px",
            right: "20px",
            top: "5%",
            bottom: "60px",
            containcolor_3: true,
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.day.lists.dates,
          },
          yAxis: [
            {
              name: "销售额",
              type: "value",
              axisLabel: {
                formatter: function () {
                  return "";
                },
              },
            },
            {
              name: "订单量",
              type: "value",
              axisLabel: {
                formatter: function () {
                  return "";
                },
              },
            },
          ],
          series: [
            {
              name: "销售额",
              type: "line",
              data: this.day.lists.price,
              yAxisIndex: 0,
              smooth: true,
            },
            {
              name: "订单量",
              type: "line",
              data: this.day.lists.num,
              yAxisIndex: 1,
              smooth: true,
            },
          ],
        });
      }
    },
  },
  created() {
    this.get_info();
    window.h5sdk.ready(function () {
      window.h5sdk.biz.navigation.setTitle({ title: "租凭统计" });
    });
  },
  updated() {
    console.log("updated....");
    this.echartInit();
  },
};
</script>

<style lang="scss" scoped>
.seomain {
  background-color: #f3f3f3;
}
.unline {
  margin: 5px 0;
}
.default_program {
  text-align: center;
  width: 100%;
}
.default_program ul li {
  float: left;
  width: 22%;
  background: #f9f9f9;
  margin-right: 4%;
  margin-bottom: 10px;
}
.default_program ul li:nth-child(4n) {
  margin-right: 0;
}
.default_program ul li:hover {
  background: #f1f1f1;
}
.default_program2 ul li {
  float: left;
  width: 48%;
  background: #f9f9f9;
  margin-right: 4%;
  margin-bottom: 18px;
  height: 82px;
  padding: 10px;
  box-sizing: border-box;
  font-size: 12px;
  color: #999;
}
.default_program2 ul li:nth-child(2n) {
  margin-right: 0;
}
.default_program2 ul li:nth-child(3) {
  width: 100%;
}
.default_program2 ul li:hover {
  background: #f3f3f3;
}
.default_program .i_backgraounds {
  text-align: center;
  margin: 0 auto;
  display: block;
  padding: 5px 0;
}
.default_program2 p {
  line-height: 55px;
  font-size: 22px;
  color: #303133;
}
.i_backgraounds i {
  font-size: 28px;
}
.default_program p {
  text-align: center;
  background: #fff;
  line-height: 30px;
  font-size: 12px;
  clear: both;
}
.default_block_col {
  margin-bottom: 20px;
}
.default_copyright ul li {
  line-height: 66px;
  border-bottom: 1px solid #efefef;
}
.default_copyright ul li:nth-child(3) {
  border-bottom: none;
}
.default_copyright ul li span {
  margin-right: 60px;
}
.default_tongbi_left {
  float: left;
}
.default_tongbi_right {
  float: left;
  margin-left: 40px;
}
.default_tongbi:after {
  clear: both;
  content: "";
  display: block;
}
.default_total:after {
  clear: both;
  content: "";
  display: block;
}
.default_tongbi {
  margin-top: 20px;
}
.default_day_sale {
  margin-top: 15px;
  margin-bottom: 21px;
}
.default_tubiao {
  width: 100%;
  margin-bottom: 20px;
}
.default_hot_goods ul li {
  margin-top: 20px;
  overflow: hidden;
}
.default_hot_goods ul li span {
  border-radius: 50%;
  background: #f5f5f5;
  width: 20px;
  height: 20px;
  text-align: center;
  display: block;
  float: left;
  margin-right: 8px;
}
.default_hot_goods ul li:nth-child(1) span {
  background: #314659;
  color: #fff;
}
.default_hot_goods ul li:nth-child(2) span {
  background: #314659;
  color: #fff;
}
.default_hot_goods ul li:nth-child(3) span {
  background: #314659;
  color: #fff;
}

.top_wrap {
  padding: 5px;
}
.top_wrap .top_content {
  position: relative;
  height: 137px;
  border-radius: 15px;
  background-color: #51596e;
}
.top_content .title {
  position: absolute;
  left: 20px;
  top: 20px;
  color: #fff;
}
.top_content .amount {
  color: #fff;
  font-size: 28px;
  line-height: 160px;
  text-align: center;
  font-weight: 700;
}
.color_1 {
  color: #00baad;
}
.color_2 {
  color: #ff5733;
}
.color_3 {
  color: #2a82e4;
}
.color_4 {
  color: #51596e;
}

.sales_amount,
.sales_amount-2 {
  line-height: 28px;
}
.type_tag {
  margin: 0 5px;
  text-align: center;
  color: #383838;
  line-height: 28px;
  background-color: #e5e5e5;
  border-radius: 5px;
}
.bottom_wrap {
  padding: 10px;
  background-color: #fff;
}
.bottom_wrap .top-tit {
  color: #51596e;
  font-size: 16px;
  line-height: 32px;
}
.bottom_wrap .title {
  padding-left: 5px;
  color: #51596e;
  font-size: 16px;
  line-height: 32px;
}
.bottom_wrap .item_wrap .item_content {
  padding: 2px 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-top: 10px;
  height: 74px;
  background-color: #e5e5e5;
  border-radius: 5px;
}
.bottom_wrap .item_wrap .item_content .title {
  align-self: flex-start;
}
.bottom_wrap .item_wrap .item_content .text {
  align-self: flex-end;
}
</style>
<style>
.item_wrap.van-col {
  padding: 0 3.33333px !important;
}
</style>